import React, { Component } from 'react';
import { getSettings } from '../services/settingService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
//import AddButton from './common/addButton';
import SettingsTable from './settingsTable';

class Settings extends Component {
  state = {
    settings: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const settings_response = await getSettings();
    this.setState({ loading: false });
    const { data: settings } = settings_response.data;
    this.setState({ settings });
  }

  getPagedData = () => {
    const { settings } = this.state;

    return { data: settings };
  };

  render() {
    const { loading } = this.state;
    const { data: settings } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        {/* <AddButton link="/settings/new" value="Add New Settings" /> */}
        <SettingsTable settings={settings} message="Exchange Rate Settings" />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default Settings;
